// Module
var code = "<div class=\"my-export-list\"> <abx-export-list class=\"my-export-list__export-list\" abx-models=\"vm.exports\" abx-fetch=\"vm.fetchExports(skip, limit)\" abx-fetch-single=\"vm.fetchSingleExport(id)\" abx-download-handler=\"vm.downloadHandler(exportSelected)\" abx-fetch-limit=\"10\"> </abx-export-list> </div> ";
// Exports
module.exports = code;